export const blackColor = '#24292C';
export const secondaryBlackColor = '#2B3033';
export const tertiaryBGColor = '#454A4B';
export const quaternaryBGColor = '#3A3E41';
export const darkGreyColor = '#454A4B';
export const greyColor = '#939696';
export const whiteColor = '#F7F7F7';

export const toastOptions = {
	position: 'bottom-center',
	autoClose: 7000,
	hideProgressBar: true,
	closeOnClick: true,
	pauseOnHover: true,
	draggable: true,
	progress: undefined,
	theme: 'dark',
};
